import React from "react";
import {
  Container,
  InnerContainer,
  InnerText,
  InnerWrapper
} from "./styled-components";
import buildColor from "../../_static/ColorPalette";

export const getTypeColors = (type, isSelected) => {
  if (type === "GREEN") {
    if (isSelected) {
      return {
        color: buildColor("green", "000"),
        backgroundColor: buildColor("green", "500"),
        opacity: 1
      };
    }

    return {
      color: buildColor("green", "300"),
      backgroundColor: buildColor("green", "300"),
      opacity: 0.5
    };
  }

  return {
    color: buildColor("green", "000"),
    backgroundColor: buildColor("green", "500"),
    opacity: 1
  };
};

export const ParallelogramProgressBarAtom = ({
  qaLabel,
  type,
  marginTop = 0,
  marginBottom = 0,
  isShortened = false,
  items = []
}) => (
  <Container
    data-qa-label={qaLabel}
    marginTop={marginTop}
    marginBottom={marginBottom}
    isShortened={isShortened}
  >
    {items.map(({ text, width, isSelected = false, marginRight = 0 }) => {
      const {
        color,
        backgroundColor,
        opacity = 1
      } = getTypeColors(type, isSelected);

      return (
        <InnerWrapper
          key={`progress-${text}`}
          isWidth={width}
          marginRight={marginRight}
        >
          <InnerContainer
            backgroundColor={backgroundColor}
            isWidth={width}
            isOpacity={opacity}
            isShortened={isShortened}
          />
          <InnerText
            data-qa-label={`${text}-${qaLabel}`}
            color={color}
            isShortened={isShortened}
          >
            {text}
          </InnerText>
        </InnerWrapper>
      );
    })}
  </Container>
);

export default ParallelogramProgressBarAtom;
